import { Box, Fieldset, Flex, Link, Text, Textarea } from '@chakra-ui/react';
import { FormField } from '@ui/components/FormField';
import { MaskIcon } from '@ui/components/MaskIcon';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { useFormContext } from 'react-hook-form';

import type { CreateAgentFormValues } from '../constants';
import { ImageUpload } from '../ImageUpload';
import { useCreateAgentModal } from '../useCreateAgentModal';
import Subtitle from './Subtitle';

export const CreateAgentBasicInfo = () => {
  const step = useCreateAgentModal((s) => s.step);
  const { trigger, setValue } = useFormContext<CreateAgentFormValues>();

  return (
    <Box hidden={step !== 'BasicInfo'}>
      <Subtitle mb={6}>
        Let&apos;s bring your digital companion to life! (◕‿◕✿)
      </Subtitle>
      <Fieldset.Root display="flex" flexDir="column" gap={4}>
        <Fieldset.Content>
          <FormField
            name="name"
            label="Name"
            placeholder="Agent Name (make it kawaii)"
            validators={{
              required: 'Name is required',
              minLength: { value: 3, message: 'Name is too short' },
            }}
          />
          <FormField
            name="ticker"
            label="Ticker"
            placeholder="Ticker"
            validators={{
              required: 'Ticker is required',
              minLength: { value: 2, message: 'Ticker is too short' },
            }}
          />
          <FormField
            minH="160px"
            name="description"
            label="Description"
            placeholder="Describe their story so far"
            ChakraComponent={Textarea}
            validators={{
              required: 'Description is required',
              minLength: { value: 10, message: 'Description is too short' },
            }}
          />
          <Flex
            align="center"
            color="primary"
            gap={1}
            mt={-3}
            width="fit-content"
            asChild
          >
            <Link href={EXTERNAL_LINK.gitbookHowToDescribe} target="_blank">
              <MaskIcon boxSize="16px" icon="url(/masks/idea.svg)" />
              <Text textStyle="body2Bold">How to describe my agent</Text>
            </Link>
          </Flex>
          <ImageUpload
            setImage={(image) => {
              setValue('image', image);
              trigger('image');
            }}
          />
          <FormField
            name="image"
            label="Image"
            validators={{
              required: 'Image is required',
            }}
            hidden
          />
        </Fieldset.Content>
      </Fieldset.Root>
    </Box>
  );
};
